import { isBrowser, isProduction } from 'src/utils'

if (isBrowser() && isProduction()) {
  console.log = () => ({})
}
